import {
	Component,
	OnInit,
	ElementRef,
	ViewChildren,
	ViewChild,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Inject,
	NgZone,
	ViewRef
}
from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { ReplaySubject, BehaviorSubject } from 'rxjs';
//Service
import { ThongTinHangVeService } from '../phieu-thong-tin-hang-ve-ver2-service/phieu-thong-tin-hang-ve-ver2.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
import { KeHoachHangVeTTHVService } from '../ke-hoach-hang-ve-service/ke-hoach-hang-ve.service';
//Model
import { DeNghiNhapKho, DeNghiNhapKhoChiTiet, KeHoachHangVe, FileDinhKem, DSFileImport, FileImport } from '../phieu-thong-tin-hang-ve-ver2-model/phieu-thong-tin-hang-ve-ver2.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import moment from 'moment';
//Component
import { XacNhanKiemTraComponent } from '../xac-nhan-kiem-tra-dialog/xac-nhan-kiem-tra-dialog.component';

import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { async } from '@angular/core/testing';

@Component({
	selector: 'm-kiem-tra-hang',
	templateUrl: './kiem-tra-hang.component.html',
	styleUrls: ['../phieu-thong-tin-hang-ve-ver2.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})

export class PhieuKiemTraComponent implements OnInit {

	/*Config Form */
	CONFIG: CommonConFig;

    /* Comment columns mat-table
		Các trường columns cho bảng:
		- displayedColumns: display ra form
		- availableColumns: các cột sẽ được add vào display.
		- extendsColumns: các cột mở rộng thêm cho display khi QC kiểm tra
	*/
	displayedColumns = [];
	availableColumns = [
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 2,
			name: 'MaHH',
			displayName: 'Mã hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'TenHH',
			displayName: 'Tên hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'QuyCach',
			displayName: 'Quy cách',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 5,
			name: 'TenDVT',
			displayName: 'ĐVT',
			alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'Soluongkehoach',
            displayName: 'SL kế hoạch',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'Soluongchungtu',
            displayName: 'SL chứng từ',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'SoLuongThucNhap',
            displayName: 'SL thực nhập',
            alwaysChecked: false,
			isShow: true
		},
		{
			stt: 8,
			name: 'Solo',
			displayName: 'Số lô',
			alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'Warning',
            displayName: 'Cảnh báo SL KH & CT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'SoPhieuDNMH',
            displayName: 'Số phiếu ĐNMH',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'SoPhieuDH',
            displayName: 'Số phiếu ĐHM',
            alwaysChecked: false,
			isShow: true
		},
	
		{
			stt: 9,
			name: 'MaNCC',
			displayName: 'Mã NCC',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 10,
			name: 'TenNCC',
			displayName: 'Nhà cung cấp',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 10,
			name: 'TenNguoiNhanHang',
			displayName: 'Người nhận hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 11,
			name: 'TenPBKiemTra',
			displayName: 'Phòng ban kiểm tra',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 12,
			name: 'Ghichulohang',
			displayName: 'Ghi chú',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 13,
			name: 'TenNguoiKiemTra',
			displayName: 'Người kiểm tra',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 14,
			name: 'Ngaykiemtra',
			displayName: 'Ngày kiểm tra',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 15,
			name: 'Quyetdinhlohang',
			displayName: 'Kết quả pass hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 15,
			name: 'SoLuongPhuHop',
			displayName: 'SL phù hợp',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 15,
			name: 'SoLuongKhongPhuHop',
			displayName: 'SL không phù hợp',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 15,
			name: 'QuyetDinhTra',
			displayName: 'Quyết định trả',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 15,
			name: 'SoLuongTraHang',
			displayName: 'SL trả',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 16,
			name: 'GhiChuKetQuaKiemTra',
			displayName: 'Ghi chú trả hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 16,
			name: 'TrangThaiPassHang',
			displayName: 'Trạng thái pass hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
		    stt: 99,
		    name: 'actions',
		    displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
		}
	];

	displayedFileTable = [];
	FileTableColumn = [
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 2,
			name: 'FileName',
			displayName: 'Tên tệp',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'GhiChu',
			displayName: 'Ghi chú',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 99,
			name: 'actions',
			displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
		}
	];
	/* End comment columns mat-table -------------------------------------*/

	/* Mat select search cho nhân viên nhận hàng - QC kiểm tra */
	listIdNV: any[] = [];
	selectIdNV: string = '';
	filteredIdNV: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	IdNVFilterCtrl: string = '';
	haveElementIdNV: boolean = false;
	arrayNVForEachHH: any[] = [];
	arrayNVTempForEachHH: any[] = [];
	/* ------------------------------------------------------------------ */

	/* Danh sách trạng thái */
	listState: any[] = [];
	nameState: string = '';
	/* ------------------------------------------------------------------ */

	/* Selection */
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<DeNghiNhapKhoChiTiet>(true, []);

	selectedFileTableColumns = new SelectionModel<any>(true, this.FileTableColumn);
	selectionFileTable = new SelectionModel<FileDinhKem>(true, []);
	/* ------------------------------------------------------------------ */

	/* Loading.... */
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */

	/* Extend field:  */
	previousIndex: number; 				// Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2;                		 // Số chữ số phần thập phân cho kiểu dữ liệu số.
	isChange: boolean = false;			// Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	isZoomSize: boolean = false;    	// Trường đánh dấu có đang ở trạng thái zoom size hay không
	saveAddedTTHV: number[] = []		// Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	viewLoading: boolean = false;   	// Loading khi mở dialog
	canEdit: boolean = true;			// Dialog có thể chỉnh sửa không?
	isSendPBKT: boolean = false;		// Gửi bộ phận mua hàng xác nhận?
	disableButton: boolean = true;		// Tắt nút thêm mới hàng khi chưa nhập đủ
	minDate: any;						// Lưu min date của ngày hiện tại
	/* ------------------------------------------------------------------ */

	/* Các Sub form trên dialog:  */
	ThongTinHangVeForm: FormGroup;				//Form phiếu đề nghị
	hasFormErrors: boolean = false;

	FileForm: FormGroup;			//Form add hàng hóa cho phiếu

	/* ------------------------------------------------------------------ */

	/* Item dữ liệu từ của phiếu đề nghị khi mở dialog:  */
	thongTinHangVeItem: DeNghiNhapKho;

	/* Danh sách chi tiết hàng hóa của phiếu đề nghị:  */
	listChiTietHangVe: DeNghiNhapKhoChiTiet[] = [];

	/* Danh sách tạm chi tiết hàng hóa của phiếu đề nghị dùng để cập nhập trên lưới  */
	tmpChiTietHangVe: DeNghiNhapKhoChiTiet[] = [];
	originalChiTietHangVe: DeNghiNhapKhoChiTiet[] = [];

	returnListKeHoachHangVe: KeHoachHangVe[] = [];

	/*Xử lý File đính kèm */
	listFileName: string[] = [];
	listFileDinhKem: FileDinhKem[] = [];
	dataArray: FileImport[] = [];

	optionsTinhTrang = [
		{
			id: 1,
			name: 'Đang soạn thảo',
			value: 'PTTHV_PHIEUMOI',
		},
		{
			id: 2,
			name: 'Chờ xử lý',
			value: 'PTTHV_CHOKQKT',
		},
		{
			id: 3,
			name: 'Hoàn tất',
			value: 'PTTHV_HOANTAT',
		},
		{
			id: 4,
			name: 'Đã hủy',
			value: 'PTTHV_DAHUY',
		}
	];
	
	constructor(
		public dialogRef: MatDialogRef<PhieuKiemTraComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private thongTinHangVeService: ThongTinHangVeService,
		private keHoachHangVeService: KeHoachHangVeTTHVService,
		private ThongTinHangVeFB: FormBuilder,
		private FileFB: FormBuilder,
		public dialog: MatDialog,
		private route: ActivatedRoute,
		private router: Router,
		private datePipe: DatePipe,
		private tokenStorage: TokenStorage,
		private translate: TranslateService,
		private subheaderService: SubheaderService,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private el: ElementRef,
		private ngZone: NgZone
	) {
		this.dialogRef.disableClose = true;
	}

	/** LOAD DATA */
	ngOnInit() {
		/*Get data from list when open dialog */
		this.thongTinHangVeItem = this.data.data;
		this.canEdit = this.data.canEdit;

		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		/*Load all dropdown and create form */
		this.createForm();
		this.ListState();
		this.ListIdNv();

		/*Handel keydown event in dialog*/
		this.dialogRef.keydownEvents().subscribe(event => {
			
			if (event.key == "Escape") {
				this.back();
			}
			
			else if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.XACNHAN_PASSHANG.KeyCombine.keycode) {
				
				if (this.isDisableCornFirmButton()) {
					
					this.layoutUtilsService.showErorr('Vui lòng nhập đủ thông tin cho hàng hóa');
					return;
				}
				this.onSubmit();
			}
		});

		/*Show column */
		this.showColumnsInTable();
		this.applySelectedColumns();
		this.applyFileTableColumns();
		this.changeDetect.detectChanges();
	}

	/*Create Form with appropriate sub forms */
	createForm() {
		
		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });

		this.minDate = new Date();
		/*Group các Form */
		this.ThongTinHangVeForm = this.ThongTinHangVeFB.group({
			SoPhieu: [!(this.thongTinHangVeItem.Sophieu == undefined || this.thongTinHangVeItem.Sophieu == '') ? this.thongTinHangVeItem.Sophieu : '', Validators.required],
			NgayLapPhieu: [!(this.thongTinHangVeItem.Ngaynhap == undefined || this.thongTinHangVeItem.Ngaynhap == '') ? this.thongTinHangVeItem.Ngaynhap : new Date(), Validators.required],
			TenNguoiLap: [this.thongTinHangVeItem.IdDn > 0 ? this.thongTinHangVeItem.TenNguoitao : tenNguoiLap],
			TrangThai: [this.nameState],
		});
		/*Disable các trường dữ liệu không thay đổi */
		this.ThongTinHangVeForm.disable();

		/*Add dữ liệu chi tiết */
		if (this.thongTinHangVeItem.listChiTietNhapKho.length > 0) {
			this.listChiTietHangVe = this.thongTinHangVeItem.listChiTietNhapKho;
			this.tmpChiTietHangVe = [];
			this.originalChiTietHangVe = [];
			for (let i = 0; i < this.listChiTietHangVe.length; i++) {
				let tmpElement = new DeNghiNhapKhoChiTiet();
				tmpElement.copy(this.listChiTietHangVe[i]);

				tmpElement.Ngaykiemtra = moment(new Date()).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
				if (tmpElement.Nguoikiemtra == 0) {
					tmpElement.Nguoikiemtra = +idUser
				}
				if(tmpElement.Quyetdinhlohang==-1){
					tmpElement.Quyetdinhlohang = 0
				}
				let tmpElementV2 = new DeNghiNhapKhoChiTiet();
				tmpElementV2.copy(tmpElement);
				this.tmpChiTietHangVe.push(tmpElement);
				this.originalChiTietHangVe.push(tmpElementV2);
			}
			this.tmpChiTietHangVe = [...this.tmpChiTietHangVe];

			if (this.thongTinHangVeItem.listFileDinhKem != null
				&& this.thongTinHangVeItem.listFileDinhKem.length > 0) {
				this.listFileDinhKem = this.thongTinHangVeItem.listFileDinhKem;
				this.listFileDinhKem = [...this.listFileDinhKem];
			}
			//this.disableButton = this.isDisableCornFirmButton();
			this.disableButton = this.checkDisableCornFirmButton();
			
		}
	}

	toggleboolean(index: any){

		this.tmpChiTietHangVe[index].isShow=!this.tmpChiTietHangVe[index].isShow;
		this.originalChiTietHangVe[index].isShow=!this.originalChiTietHangVe[index].isShow;
	}

	clearData(index: any){
		if(this.tmpChiTietHangVe. length > 0){
			this.tmpChiTietHangVe[index].copy(this.originalChiTietHangVe[index]);
			this.tmpChiTietHangVe = [...this.tmpChiTietHangVe];
			this.disableButton = this.checkDisableCornFirmButton();
			this.changeDetect.detectChanges();
		}
	}

	/*Lấy tiêu đề cho dialog*/
	getTitle(): string {
		return `Kiểm tra hàng pass nhanh`;
	}

	/*Lấy tên theo id của quyết định */
	getNameOfQuyetDinhLoHang(Quyetdinhlohang: number) {
		if (Quyetdinhlohang == 0)
			return 'Nhập';
		else if (Quyetdinhlohang == 1)
			return 'Nhập 1 phần';
		else if (Quyetdinhlohang == 2)
			return 'Trả hàng';
		return '';
	}
	/*------------------------------------------------------ */

	/*Kiểm tra hàng */
	KiemTraHangHoa(item: any) {
		let tmpItem = new DeNghiNhapKhoChiTiet();
		tmpItem.copy(item);
		const dialogRef = this.dialog.open(XacNhanKiemTraComponent, {
			data: {
				data: tmpItem,
			},
		});

		dialogRef.afterClosed().subscribe(res => {
			if (res == undefined || res == null) {
				return;
			}
			else {
				
				if (res.isChange) {
					let haveContain = false;
					for (let i = 0; i < this.tmpChiTietHangVe.length; i++) {
						if (this.tmpChiTietHangVe[i].IdCtdn == res.data.IdCtdn) {
							this.tmpChiTietHangVe.splice(i, 1);
							haveContain = true;
							break;
						}
					}
					if (haveContain) {
						this.tmpChiTietHangVe.push(res.data)
						this.tmpChiTietHangVe = [...this.tmpChiTietHangVe];
						this.disableButton = this.isDisableCornFirmButton();
						this.changeDetect.detectChanges();
					}
				}
			}
		});

	}
	isDisableCornFirmButton() {
		let condition = false;
		this.tmpChiTietHangVe.forEach(element => {
			if (element.Nguoikiemtra == null || element.Nguoikiemtra == undefined
				|| element.Nguoikiemtra == 0) {
				condition = true;
			}else if(element.Quyetdinhlohang == null || element.Quyetdinhlohang == undefined
				|| element.Quyetdinhlohang == 0||element.Quyetdinhlohang==-1){
					condition = true;
				}
		})
		return condition;
	}
	checkDisableCornFirmButton() {
		let condition = false;
		this.originalChiTietHangVe.forEach(element => {
			if (element.Nguoikiemtra == null || element.Nguoikiemtra == undefined || element.Nguoikiemtra == 0) {
				condition = true;
			}else if(element.Quyetdinhlohang == null || element.Quyetdinhlohang == undefined ||element.Quyetdinhlohang ==-1){
					condition = true;
				}
		})
		return condition;
	}
	/*------------------------------------------------------------- */
	/*Lưu kết quả kiểm tra */
	onSubmit() {
		let tmpCheckGhiChu = false;
		this.tmpChiTietHangVe.forEach(element => {
			if (+element.Quyetdinhlohang == 2 && (element.GhiChuKetQuaKiemTra == null
				|| element.GhiChuKetQuaKiemTra == '')) {
				this.layoutUtilsService.showErorr('Vui lập nhập ghi chú KQKT với trường hợp trả hàng');
				tmpCheckGhiChu = true;
			}
		})
		if (tmpCheckGhiChu) return null;

		const dialogRef = this.layoutUtilsService.POP02(this.thongTinHangVeItem.Sophieu);
		dialogRef.afterClosed().subscribe(res => {
			if (!res) {
				return;
			}
			this.tmpChiTietHangVe.forEach(element => {
				element.Nguoikiemtra = +element.Nguoikiemtra;
				element.Ngaykiemtra = moment(new Date(element.Ngaykiemtra)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
				element.Quyetdinhlohang = +element.Quyetdinhlohang;
				element.QuyetDinhTra = +element.QuyetDinhTra;
			})
			let checkStatusHH_NCPB= this.tmpChiTietHangVe.filter(x=>x.LoaiPhieu=="Nhu cầu phòng ban");

			if (checkStatusHH_NCPB.length==this.tmpChiTietHangVe.length) {
				this.thongTinHangVeItem.Tinhtrang = this.optionsTinhTrang[2].value;
			}else{
				this.thongTinHangVeItem.Tinhtrang = this.optionsTinhTrang[1].value;
			}
			this.thongTinHangVeItem.listChiTietNhapKho=this.tmpChiTietHangVe;

			this.thongTinHangVeService.XacNhanKiemTra(this.thongTinHangVeItem).subscribe(res => {
					if (res.status == 1) {
						const message='Cập nhật kết quả pass hàng thành công';
						this.layoutUtilsService.showInfo(message);
						this.saveAddedTTHV = [];
						this.saveAddedTTHV.push(this.thongTinHangVeItem.IdDn);
						this.back();
					}
					else {
						this.layoutUtilsService.showErorr(res.error.message);
					}
				});
		});
	}
	checkDisableConfirm() {
		for (let i = 0; i < this.tmpChiTietHangVe.length; i++) {
			if (this.tmpChiTietHangVe[i].Nguoikiemtra <= 0 || this.tmpChiTietHangVe[i].Ngaykiemtra == ""
				|| this.tmpChiTietHangVe[i].Quyetdinhlohang == -1) {
				this.disableButton = true;
				return null;
			}
		}
		this.disableButton = false;
		this.changeDetect.detectChanges();
	}
	saveItem(index: any){
		if (this.tmpChiTietHangVe[index].Nguoikiemtra == null || this.tmpChiTietHangVe[index].Nguoikiemtra == undefined || +this.tmpChiTietHangVe[index].Nguoikiemtra == 0) {
			this.layoutUtilsService.showErorr('Vui lòng chọn người kiểm tra');
			return;
		}
		if (this.tmpChiTietHangVe[index].Quyetdinhlohang == 2 
			&& (this.tmpChiTietHangVe[index].GhiChuKetQuaKiemTra == null 
				|| this.tmpChiTietHangVe[index].GhiChuKetQuaKiemTra == '')) {
			this.layoutUtilsService.showErorr('Vui lòng nhập ghi chú trả hàng với trường hợp trả hàng');
			return;
		}

		if (this.tmpChiTietHangVe[index].Quyetdinhlohang == 2 
			&& this.tmpChiTietHangVe[index].QuyetDinhTra < 1) {
			this.layoutUtilsService.showErorr('Vui lòng nhập quyết định trả với trường hợp trả hàng');
			return;
		}

		const dialogRef = this.layoutUtilsService.POP02('');
		const _deleteMessage = `Chi tiết phiếu cập nhật thành công`;
		dialogRef.afterClosed().subscribe(res => {
			if (!res) {
				return;
			}
			this.tmpChiTietHangVe[index].Nguoikiemtra = +this.tmpChiTietHangVe[index].Nguoikiemtra;
			this.tmpChiTietHangVe[index].Ngaykiemtra = moment(new Date(this.tmpChiTietHangVe[index].Ngaykiemtra)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
			this.tmpChiTietHangVe[index].Quyetdinhlohang = +this.tmpChiTietHangVe[index].Quyetdinhlohang;
			if(this.tmpChiTietHangVe[index].SoLuongTraHang != null && this.tmpChiTietHangVe[index].SoLuongTraHang != undefined)
				this.tmpChiTietHangVe[index].SoLuongTraHang = this.FormatCommaNumber(this.tmpChiTietHangVe[index].SoLuongTraHang.toString())
			
			this.thongTinHangVeService.KiemTraTungHang(this.tmpChiTietHangVe[index]).subscribe(res => {
				if (res.status == 1) {
					const message='Xác nhận hàng thành công';
					this.layoutUtilsService.showInfo(message);
					
					this.tmpChiTietHangVe[index].TrangThaiPassHang = res.data.TrangThaiPassHang;
					this.tmpChiTietHangVe[index].TenNguoiKiemTra = res.data.TenNguoiKiemTra;
					this.originalChiTietHangVe[index].copy(this.tmpChiTietHangVe[index]);
					
					this.disableButton = this.checkDisableCornFirmButton();
					this.toggleboolean(index);
					this.changeDetect.detectChanges();
				}
				else {
					this.layoutUtilsService.showErorr(res.error.message);
				}
			});	
		});
	
	}
	checkShowXacNhan(item: any){
		var phongban = '';
		this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });
		let element = this.tmpChiTietHangVe.find(x => x.IdCtdn == item.IdCtdn);
		if(element != null && (element.PbkiemTraId == +phongban)){
			return true;
		}
		return false;
	}
	isTPDuyetCase(index: any){
		let isAllConfirm = true;
		this.tmpChiTietHangVe.forEach(element =>{
			if(element.Nguoikiemtra == null || element.Nguoikiemtra == 0){
				isAllConfirm = false;
			}
		})
		if(isAllConfirm && (this.tmpChiTietHangVe[index].listNV.find(x => x.Id_NV == +this.tmpChiTietHangVe[index].Nguoikiemtra) == null ))
			return true;
		return false;
	}
	checkWarningState(item: DeNghiNhapKhoChiTiet){
		var tmp = Number(item.Soluongkehoach) * item.DungSai / 100;
		var result = -1;

		if(Number(item.Soluongchungtu) > Number(item.Soluongkehoach) + tmp){
			result = 0;
		}
		if((Number(item.Soluongkehoach) - tmp) <= Number(item.Soluongchungtu)
		&& (Number(item.Soluongchungtu) <= Number(item.Soluongkehoach) + tmp)){
			result = 1;
		}
		if(Number(item.Soluongchungtu) < Number(item.Soluongkehoach) - tmp){
			result = 2;
		}
		return result;
	}
	warningState(item: DeNghiNhapKhoChiTiet ){
		let result = this.checkWarningState(item);
		switch(result){
			case 0:
				return '> dung sai cho phép';
			case 1:
				return 'Thuộc dung sai cho phép';
			case 2:
				return '< dung sai cho phép';
			default:
				return ''
		}
	}
	cssWarningState(item:DeNghiNhapKhoChiTiet){
		let result = this.checkWarningState(item);
		switch(result){
			case 0:
				return 'red';
			case 1:
				return 'green';
			case 2:
				return 'orange';
			default:
				return ''
		}
	}
	/*------------------------------------------------------------- */

	/*Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng*/
	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	applyFileTableColumns() {
		let _selectedColumns = this.selectedFileTableColumns.selected;
		this.selectedFileTableColumns = new SelectionModel<any>(true, this.FileTableColumn);
		for (let i = 0; i < this.FileTableColumn.length; i++) {
			this.selectedFileTableColumns.toggle(this.FileTableColumn[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.FileTableColumn[i].name == _selectedColumns[j].name) {
					this.selectedFileTableColumns.toggle(this.FileTableColumn[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedFileTableColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedFileTable = _applySelectedColumns;
	}
	/*---------------------------------------------------------------------------------------- */

	/*Các hàm hỗ trợ cho mat select search Nhân viên*/
	ListIdNv() {
		this.listChiTietHangVe.forEach(element => {
			let filterTmp = new ReplaySubject<any[]>(1)
			filterTmp.next(element.listNV.slice());
			this.arrayNVForEachHH.push(filterTmp);
		})
	
	
		this.changeDetect.detectChanges();
	
	}

	filterIdNv(item: any) {
		if (!this.listIdNV) {
			return;
		}
		// get the search keyword
		let search = this.IdNVFilterCtrl;
		let index = this.tmpChiTietHangVe.indexOf(item)

		if (!search) {
			this.arrayNVForEachHH[index].next(item.listNV.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		if (index > -1) {
			this.arrayNVForEachHH[index].next(item.listNV.filter(ts =>
				ts.TenNV.toLowerCase().indexOf(search) > -1)
			);
		}
		this.changeDetect.detectChanges();
	}
	/*------------------------------------------ */

	/*Hàm lấy danh sách trạng thái phiếu*/
	ListState() {
		this.keHoachHangVeService.listState().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listState = res.data;
				this.checkState();
				this.changeDetect.detectChanges();
			};
		});
	}
	checkState() {
		this.listState.forEach(element => {
			if (element.Code == this.thongTinHangVeItem.Tinhtrang) {
				this.nameState = element.Description;
				if (this.ThongTinHangVeForm != null)
					this.ThongTinHangVeForm.controls["TrangThai"].setValue(this.nameState);
			}
		});
	}
	getTrangThaiDetail(state: string){
		let item = DeNghiNhapKhoChiTiet.optionTrangThaiDetail.find(x => x.value == state)
		if(item != null){
			return item.name;
		}
		return '';
	}
	/*---------------------------------------- */

	/*Các hàm hỗ trợ cho thay đổi - cập nhập dữ liệu trên bảng*/
	canUpdateElementOnGrid(item: any) {
		if (this.canEdit && !this.thongTinHangVeItem.isQCKiemTra && (item.Nguoikiemtra == undefined || item.Nguoikiemtra == 0)) {
			return true;
		}
		else if (this.canEdit && this.thongTinHangVeItem.isQCKiemTra) {
			if (item.Nguoikiemtra == undefined || item.Nguoikiemtra == 0) {
				return true;
			}
		}
		return false;
	}
	changeValueOfColumn(columnName:string, item:any, event: any, afterUpdate: boolean){
		
		if(columnName == 'Soluongchungtu'){
			if(afterUpdate)
				this.tmpChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Soluongchungtu = this.formatNumber(item.Soluongchungtu);
			else if(!afterUpdate ){
				let index= this.tmpChiTietHangVe.indexOf(item);
				if(this.ValidateChangeNumberEvent(columnName,{},event)){
					let item = this.data.selected.filter(x => x.Id == this.tmpChiTietHangVe[index].IdDHCT);
					
					if(item.length>0){
						let soluong=Number(this.FormatCommaNumber(event.target.value.trim()));
						if(item[0].SoLuong<Number(this.FormatCommaNumber(event.target.value.trim()))||soluong==0)
						{
							this.tmpChiTietHangVe[index].Soluongchungtu=item[0].SoLuong+'';
						}else{
							this.tmpChiTietHangVe[index].Soluongchungtu=event.target.value.trim();
						}
					}else{
						this.tmpChiTietHangVe[index].Soluongchungtu=event.target.value.trim();
					}
					
				}
			}
		}
		if(columnName == 'SoLuongTraHang'){
			if(afterUpdate)
				this.tmpChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].SoLuongTraHang = this.formatNumber(item.SoLuongTraHang);
			else if(!afterUpdate ){
				let index= this.tmpChiTietHangVe.indexOf(item);
				if(this.ValidateChangeNumberEvent(columnName,{},event)){
					let item = this.data.selected.filter(x => x.Id == this.tmpChiTietHangVe[index].IdDHCT);
					
					if(item.length>0){
						let soluong=Number(this.FormatCommaNumber(event.target.value.trim()));
						if(item[0].SoLuong<Number(this.FormatCommaNumber(event.target.value.trim()))||soluong==0)
						{
							this.tmpChiTietHangVe[index].SoLuongTraHang=item[0].SoLuong+'';
						}else{
							this.tmpChiTietHangVe[index].SoLuongTraHang=event.target.value.trim();
						}
					}else{
						this.tmpChiTietHangVe[index].SoLuongTraHang=event.target.value.trim();
					}
					
				}
			}
		}

		if(columnName == 'SoLuongThucNhap'){
			if(afterUpdate)
				this.tmpChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].SoLuongThucNhap = this.formatNumber(item.SoLuongThucNhap);
			else if(!afterUpdate ){
				let index= this.tmpChiTietHangVe.indexOf(item);
				if(this.ValidateChangeNumberEvent(columnName,{},event)){
					let item = this.data.selected.filter(x => x.Id == this.tmpChiTietHangVe[index].IdDHCT);
					
					if(item.length>0){
						let soluong = Number(this.FormatCommaNumber(event.target.value.trim()));
						if(item[0].SoLuongThucNhap < Number(this.FormatCommaNumber(event.target.value.trim()))|| soluong==0)
						{
							this.tmpChiTietHangVe[index].SoLuongThucNhap=item[0].SoLuongThucNhap+'';
						}else{
							this.tmpChiTietHangVe[index].SoLuongThucNhap=event.target.value.trim();
						}
					}else{
						this.tmpChiTietHangVe[index].SoLuongThucNhap=event.target.value.trim();
					}
					
				}
			}
		}

		if(columnName == 'Solo'){
			if(afterUpdate)
			this.tmpChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Solo = item.Solo
			else if(!afterUpdate){
				this.tmpChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Solo = event.target.value.trim();
				//this.updateValueColumn('Solo',item);
			}
		}

		if(columnName == 'Ghichulohang'){
			if(afterUpdate)
			this.listChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Ghichulohang = item.Ghichulohang
			else if(!afterUpdate){
				this.tmpChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Ghichulohang = event.target.value.trim();
				//this.updateValueColumn('Ghichulohang',item);
			}
		}

		this.tmpChiTietHangVe=[...this.tmpChiTietHangVe];
		this.changeDetectView();

	}
	isChangeValueOfColumn(columnName: string, item: any) {
		if (columnName == 'Solo' && this.tmpChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Solo != this.listChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Solo)
			return true;
		if (columnName == 'Soluongchungtu' && this.tmpChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Soluongchungtu != this.listChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Soluongchungtu)
			return true;

		return false;
	}
	updateValueColumn(columnName: string, item: any) {
		this.tmpChiTietHangVe = [...this.tmpChiTietHangVe];
	}
	resetValueUpdate(columnName: string, item: any) {
		if (columnName == 'Soluongchungtu') {
			this.tmpChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Soluongchungtu = this.listChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Soluongchungtu;
		}
		if (columnName == 'Solo') {
			this.tmpChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Solo = this.listChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Solo;
		}
	}
	ValidateChangeNumberEvent(columnName: string, item: any, event: any) {
		var count = 0;
		for (let i = 0; i < event.target.value.length; i++) {
			if (event.target.value[i] == '.') {
				count += 1;
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showActionNotification(message, MessageType.Create, 3000, true, false);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showActionNotification(message, MessageType.Create, 3000, true, false);
			return false;;
		}
		return true;
	}
	/*---------------------------------------------------------------------------------------- */

	/*Hàm hỗ trợ format các dạng số trên form*/
	ValidateChangeNumberForm(event: any, isEvent: boolean = true) {
		var count = 0;
		if (isEvent) {
			for (let i = 0; i < event.target.value.length; i++) {
				if (event.target.value[i] == '.') {
					count += 1;
				}
			}
		}
		else {
			for (let i = 0; i < event.length; i++) {
				if (event[i] == '.') {
					count += 1;
				}
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = isEvent ? event.target.value.toString().match(regex) : event.toString().match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showActionNotification(message, MessageType.Create, 3000, true, false);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showActionNotification(message, MessageType.Create, 3000, true, false);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == null || value == undefined || value == '') return '';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	FormatCommaNumber(item: string) {
		return item.replace(/,/g, "");
	}
	/*------------------------------------------------------------- */

	/*Hàm hỗ trợ format các dạng ngày trên form*/
	getFormatDate(v: string = '') {
		if (v == null || v == undefined || v == '')
			return '';
		if (v != '') {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
	}
	f_convertDate(p_Val: any) {
		if (p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	minMaxDate(p_Val: any, item: any) {
		
		let d1 = new Date(p_Val);
		let d2 = new Date();

		if (d1.getTime() < d2.getTime()) {
			this.tmpChiTietHangVe[this.tmpChiTietHangVe.indexOf(item)].Ngaykiemtra = moment(new Date()).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
			this.tmpChiTietHangVe = [...this.tmpChiTietHangVe];
		}
		this.changeDetect.detectChanges();
	}
	/*------------------------------------------------------------- */

	/*Đóng dialog và cập nhập lại tình trạng, trả về highlight ID nếu có*/
	back() {
		this.dialogRef.close(
			{
				isChange: this.isChange,		//Dữ liệu có thay đổi hay không?
				dataAdd: this.returnListKeHoachHangVe,
				PTTHVNew: this.saveAddedTTHV
			}
		);
	}
	changeDetectView(){
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	/*------------------------------------------------------------- */

    /*
		Hàm hỗ trợ tổ hợp phím trên form
	*/
	onKeydownMain(event: KeyboardEvent) {
		//Tham khảo keyCode của event theo link: https://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes
		if (event.altKey && event.keyCode == 83) {
			this.onSubmit();
		}
	}
	/*------------------------------------------------------------- */

}